module.exports = __webpack_public_path__ + "media/images/meta/admin/apple-touch-icon-local-fe2a33b10425c133df1d0a01a5499d2f.png";